import axios from '../../utils/axios'
import { setAlert } from '../alert/actions'
import { Dispatch } from 'redux'
import {
  DOWNLOAD_TRANSACTION_STATEMENTS,
  DownloadTransactionStatements,
  DOWNLOAD_TRANSACTION_STATEMENTS_SUCCESS,
  DownloadTransactionStatementsSuccess,
  DOWNLOAD_TRANSACTION_STATEMENTS_FAILED,
  DownloadTransactionStatementsFailed,
  GET_GENERAL_CONTRIBUTIONS,
  GetGeneralContributions,
  GET_GENERAL_CONTRIBUTIONS_SUCCESS,
  GetGeneralContributionsSuccess,
  GET_GENERAL_CONTRIBUTIONS_FAILED,
  GetGeneralContributionsFailed,
  GET_PERSONAL_CONTRIBUTION,
  GetPersonalContribution,
  GET_PERSONAL_CONTRIBUTION_SUCCESS,
  GetPersonalContributionSuccess,
  GET_PERSONAL_CONTRIBUTION_FAILED,
  GetPersonalContributionFailed,
  CONTRIBUTE_FUNDS,
  ContributeFunds,
  CONTRIBUTE_FUNDS_SUCCESS,
  ContributeFundsSuccess,
  CONTRIBUTE_FUNDS_FAILED,
  ContributeFundsFailed,
  SET_GENERAL_AMOUNT,
  SetGeneralAmount,
  SET_GENERAL_AMOUNT_SUCCESS,
  SetGeneralAmountSuccess,
  SET_GENERAL_AMOUNT_FAILED,
  SetGeneralAmountFailed,
  TRANSFER_TO_WALLET,
  TransferToWallet,
  TRANSFER_TO_WALLET_SUCCESS,
  TransferToWalletSuccess,
  TRANSFER_TO_WALLET_FAILED,
  TransferToWalletFailed,
  GET_GENERAL_AMOUNT,
  GetGeneralAmount,
  GET_GENERAL_AMOUNT_SUCCESS,
  GetGeneralAmountSuccess,
  GET_GENERAL_AMOUNT_FAILED,
  GetGeneralAmountFailed,
  GET_JOINT_FUND_WALLET,
  GetJointFundWallet,
  GET_JOINT_FUND_WALLET_SUCCESS,
  GetJointFundWalletSuccess,
  GET_JOINT_FUND_WALLET_FAILED,
  GetJointFundWalletFailed,
} from './constants'


export const downloadTransactionStatementsRequest = () =>
  async (
    dispatch: Dispatch<
      | DownloadTransactionStatements
      | DownloadTransactionStatementsSuccess
      | DownloadTransactionStatementsFailed
      | any
    >
  ) => {
    try {
      dispatch({ type: DOWNLOAD_TRANSACTION_STATEMENTS })
      const res = await axios.post(`/joint-funds/statement`)
      dispatch({
        type: DOWNLOAD_TRANSACTION_STATEMENTS_SUCCESS,
        payload: res
      })
    } catch (err: any) {
      if (err.response) {
        dispatch(setAlert(err.response.data.message, 'warning'))
        dispatch({
          type: DOWNLOAD_TRANSACTION_STATEMENTS_FAILED,
          payload: err.response.data.message
        })
      } else {
        dispatch(setAlert(err.message, 'error'))
        dispatch({
          type: DOWNLOAD_TRANSACTION_STATEMENTS_FAILED,
          payload: err.message
        })
      }
    }
  }

export const getGeneralContributionsRequest =
  (page?: number | undefined, pageSize?: number | undefined) =>
  async (
    dispatch: Dispatch<
      | GetGeneralContributions
      | GetGeneralContributionsSuccess
      | GetGeneralContributionsFailed
      | any
    >
  ) => {
    try {
      dispatch({ type: GET_GENERAL_CONTRIBUTIONS })
      const res = await axios.get(`/joint-fund/contributions?page=${page ?? 1}&pageSize=${pageSize ?? 20}`)

      dispatch({
        type: GET_GENERAL_CONTRIBUTIONS_SUCCESS,
        payload: res
      })
    } catch (err: any) {
      if (err.response) {
        dispatch(setAlert(err.response.data.message, 'warning'))
        dispatch({
          type: GET_GENERAL_CONTRIBUTIONS_FAILED,
          payload: err.response.data.message
        })
      } else {
        dispatch(setAlert(err.message, 'error'))
        dispatch({
          type: GET_GENERAL_CONTRIBUTIONS_FAILED,
          payload: err.message
        })
      }
    }
  }

export const getPersonalContributionsRequest =
(page?: number | undefined, pageSize?: number | undefined) =>
  async (
    dispatch: Dispatch<
      | GetPersonalContribution
      | GetPersonalContributionSuccess
      | GetPersonalContributionFailed
      | any
    >
  ) => {
    try {
      dispatch({ type: GET_PERSONAL_CONTRIBUTION })
      const res = await axios.get(`/joint-fund/user/contributions?page=${page ?? 1}&pageSize=${pageSize ?? 20}`)

      dispatch({
        type: GET_PERSONAL_CONTRIBUTION_SUCCESS,
        payload: res
      })
    } catch (err: any) {
      if (err.response) {
        dispatch(setAlert(err.response.data.message, 'warning'))
        dispatch({
          type: GET_PERSONAL_CONTRIBUTION_FAILED,
          payload: err.response.data.message
        })
      } else {
        dispatch(setAlert(err.message, 'error'))
        dispatch({
          type: GET_PERSONAL_CONTRIBUTION_FAILED,
          payload: err.message
        })
      }
    }
  }

export const contributeFundsRequest =
  (payload: any) =>
  async (
    dispatch: Dispatch<
      ContributeFunds | ContributeFundsSuccess | ContributeFundsFailed | any
    >
  ) => {
    try {
      dispatch({ type: CONTRIBUTE_FUNDS })
      const res = await axios.post(`/joint-fund/contribute`, payload)

      dispatch({
        type: CONTRIBUTE_FUNDS_SUCCESS,
        payload: res
      })
    } catch (err: any) {
      if (err.response) {
        dispatch(setAlert(err.response.data.message, 'warning'))
        dispatch({
          type: CONTRIBUTE_FUNDS_FAILED,
          payload: err.response.data.message
        })
      } else {
        dispatch(setAlert(err.message, 'error'))
        dispatch({
          type: CONTRIBUTE_FUNDS_FAILED,
          payload: err.message
        })
      }
    }
  }


export const getGeneralAmountSettingsRequest = () => async (
    dispatch: Dispatch<
      GetGeneralAmount | GetGeneralAmountSuccess | GetGeneralAmountFailed | any
    >
  ) => {
    try {
      dispatch({ type: GET_GENERAL_AMOUNT })
      const res = await axios.get(`/joint-funds/settings`)

      dispatch({
        type: GET_GENERAL_AMOUNT_SUCCESS,
        payload: res
      })
    } catch (err: any) {
      if (err.response) {
        dispatch(setAlert(err.response.data.message, 'warning'))
        dispatch({
          type: GET_GENERAL_AMOUNT_FAILED,
          payload: err.response.data.message
        })
      } else {
        dispatch(setAlert(err.message, 'error'))
        dispatch({
          type: GET_GENERAL_AMOUNT_FAILED,
          payload: err.message
        })
      }
    }
  }

export const setGeneralAmountRequest = (formData: any) =>
async (
  dispatch: Dispatch<
    SetGeneralAmount | SetGeneralAmountSuccess | SetGeneralAmountFailed | any
  >
) => {
  try {
    dispatch({ type: SET_GENERAL_AMOUNT })
    const res = await axios.put(`/joint-funds/settings`, formData)

    dispatch({
      type: SET_GENERAL_AMOUNT_SUCCESS,
      payload: res
    })
  } catch (err: any) {
    if (err.response) {
      dispatch(setAlert(err.response.data.message, 'warning'))
      dispatch({
        type: SET_GENERAL_AMOUNT_FAILED,
        payload: err.response.data.message
      })
    } else {
      dispatch(setAlert(err.message, 'error'))
      dispatch({
        type: SET_GENERAL_AMOUNT_FAILED,
        payload: err.message
      })
    }
  }
}

export const transferToWalletRequest =
  (payload: any, id: string,) =>
  async (
    dispatch: Dispatch<
      | TransferToWallet
      | TransferToWalletSuccess
      | TransferToWalletFailed
      | any
    >
  ) => {
    try {
      dispatch({ type: TRANSFER_TO_WALLET })
      const res = await axios.post(`/joint-fund/withdraw`, payload)

      dispatch({
        type: TRANSFER_TO_WALLET_SUCCESS,
        payload: res
      })
    } catch (err: any) {
      if (err.response) {
        dispatch(setAlert(err.response.data.message, 'warning'))
        dispatch({
          type: TRANSFER_TO_WALLET_FAILED,
          payload: err.response.data.message
        })
      } else {
        dispatch(setAlert(err.message, 'error'))
        dispatch({
          type: TRANSFER_TO_WALLET_FAILED,
          payload: err.message
        })
      }
    }
  }

export const getJointFundWalletRequest = () =>
    async (
      dispatch: Dispatch<
        | GetJointFundWallet
        | GetJointFundWalletSuccess
        | GetJointFundWalletFailed
        | any
      >
    ) => {
      try {
        dispatch({ type: GET_JOINT_FUND_WALLET })
        const res = await axios.get(`/joint-fund/wallet`)

        dispatch({
          type: GET_JOINT_FUND_WALLET_SUCCESS,
          payload: res
        })
      } catch (err: any) {
        if (err.response) {
          dispatch(setAlert(err.response.data.message, 'warning'))
          dispatch({
            type: GET_JOINT_FUND_WALLET_FAILED,
            payload: err.response.data.message
          })
        } else {
          dispatch(setAlert(err.message, 'error'))
          dispatch({
            type: GET_JOINT_FUND_WALLET_FAILED,
            payload: err.message
          })
        }
      }
    }